const statusColor = {
  approved: '#4CAF50', // green
  failed: '#B71C1C', //red
  pending: '#FFB800', // yellow
  adjusted: '#FFA000', //orange
  cancelled: '#9B9B9B', //grey
};

export {statusColor};
